export const formCardData = [
  {
    report_name: "Crew Movement Report",
    purpose: "Track each crew member’s check-in, check-out, and duty movement details.",
    icon: "IconUsers", 
    api: "crew_movement_report",
  },
  {
    report_name: "Inflight Report",
    purpose: "Monitor pilot and flight crew inflight check-ins, schedules, and status updates.",
    icon: "IconPlaneInflight",
    api: "inflight_report",
  },
];


